import {useSelector} from 'react-redux'
import {organisationSelectors} from '../../../../organisationSelectors'
import {useIntl} from 'react-intl'
import {useAppDispatch} from '../../../../../../infrastructure/hooks/reduxHooks'
import {subscriptionActions} from '../../subscriptionActions'
import {useEffect, useState} from 'react'
import {subscriptionSelectors} from '../../subscriptionSelectors'
import {PackageType} from "../../../../../../infrastructure/enums/packageType";
import {formatDate} from "../../../../../../infrastructure/utils/dateUtils";
import {swal} from "../../../../../../libs/sweetAlert";
import {toastify} from "../../../../../../libs/toastify";
import {subscriptionReducerActions} from "../../subscriptionSlice";

const formatPrice = (input: string): string => {
    // String'i Number'a çevirin ve 100'e bölün
    const numberValue = Number(input) / 100;

    // Sayıyı 2 ondalık basamakla formatlayın
    const formattedValue = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(numberValue);

    return formattedValue;
};

export const Detail = () => {
    const intl = useIntl()
    const dispatch = useAppDispatch()

    const [disableSubscriptionButtons, setDisableSubscriptionButtons] = useState(false)

    const organisation = useSelector(organisationSelectors.getSelectedOrganisation())
    const subscriptionInfo = useSelector(subscriptionSelectors.getSubscriptionInfo())

    useEffect(() => {
        dispatch(subscriptionActions.getSubscriptionInfo({organisationId: organisation.id}))
        
        return () => {
            dispatch(subscriptionReducerActions.setSubscriptionInfo(null));
        }
    }, [])

    return (
        <>
            <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed mb-12 p-6'>
                <i className='ki-duotone ki-information fs-2x text-warning me-4 mt-2'>
                    <svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 512 512' fill='#FFC700'>
                        <path
                            d='M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'/>
                    </svg>
                </i>

                <div className='d-flex flex-stack flex-grow-1 '>
                    <div className=' fw-semibold'>
                        <div className='fs-6 text-gray-700 '>
                            {intl.formatMessage(
                                {id: 'ORGANISATION.SUBSCRIPTION.MESSAGE.STRIPE'},
                                {
                                    stripe: (
                                        <a
                                            href='https://stripe.com'
                                            target='_blank'
                                            className='fw-bolder'
                                            rel='noreferrer'
                                        >
                                            Stripe
                                        </a>
                                    ),
                                }
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {subscriptionInfo &&
                <>
                    <div className='card  mb-5 mb-xl-10'>
                        <div className='card-header bg-dark min-h-50px'>
                            <h3 className='card-title text-white'>
                                {intl.formatMessage({id: 'ORGANISATION.SUBSCRIPTION.SERVER.TITLE'})}
                            </h3>
                        </div>

                        <div className='card-body'>
                            <div className='row'>
                                <div className='col-lg-7'>
                                    {!subscriptionInfo.server?.packageId ? (
                                            <>
                                                <h3 className='mb-2'>
                                                    {intl.formatMessage({id: 'ORGANISATION.SUBSCRIPTION.PACKAGE.TRIAL'})}
                                                </h3>

                                                <div>
                                                    {intl.formatMessage(
                                                        {id: 'ORGANISATION.SUBSCRIPTION.MESSAGE.USING_FREEMIUM_PLAN_SUB_MESSAGE'},
                                                        {br: <br/>}
                                                    )}
                                                </div>
                                            </>
                                        ) :
                                        (
                                            <>
                                                <table className="table fs-5 fw-semibold gs-0 gy-2 gx-2 m-0">
                                                    <tbody>
                                                    <tr>
                                                        <td className="text-gray-500 min-w-175px w-175px">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.LABEL.PLAN"})}:</td>
                                                        <td className="text-gray-800 min-w-200px">
                                                            <a href="#" className="text-gray-800 fw-bolder">{subscriptionInfo.server.packageName}</a>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-gray-500">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.LABEL.PRICE"})}:</td>
                                                        <td className="text-gray-800">
                                                            €{formatPrice(subscriptionInfo.server.unitAmountDecimal)} / {intl.formatMessage({id: subscriptionInfo.server.periodType == 'Monthly' ? "ORGANISATION.SUBSCRIPTION.PER_MONTH" : "ORGANISATION.SUBSCRIPTION.PER_YEAR"})}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-gray-500">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.LABEL.PAYMENT_PERIOD"})}:</td>
                                                        <td className="text-gray-800">
                                                            {intl.formatMessage({id: subscriptionInfo.server.periodType == 'Monthly' ? "ORGANISATION.SUBSCRIPTION.PER_MONTH" : "ORGANISATION.SUBSCRIPTION.PER_YEAR"})}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-gray-500">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.LABEL.VALID_DATE"})}:</td>
                                                        <td className="text-gray-800">{formatDate(subscriptionInfo.server.currentPeriodEnd)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-gray-500">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.LABEL.STATUS"})}:</td>
                                                        <td className="text-gray-800">
                                                            {
                                                                (subscriptionInfo.server.status == 'active' && subscriptionInfo.server.cancelAtPeriodEnd == false) &&
                                                                <span
                                                                    className="text-success">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.SUBSCRIPTION_STATUS_ACTIVE"})}</span>
                                                            }
                                                            {
                                                                (subscriptionInfo.server.status == 'active' && subscriptionInfo.server.cancelAtPeriodEnd == true) &&
                                                                <span
                                                                    className="text-warning">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.SUBSCRIPTION_STATUS_CANCELED"})}<br/><br/>
                                                                    {intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.SUBSCRIPTION_STATUS_CANCELED_SUB_MESSAGE"},
                                                                        {date: formatDate(subscriptionInfo.server.currentPeriodEnd)})}</span>
                                                            }</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </>
                                        )}
                                </div>
                                <div className='col-lg-5'>
                                    <div className='d-flex justify-content-end pb-0 px-0'>

                                        {
                                            (subscriptionInfo.server && subscriptionInfo.server.status == "active" && subscriptionInfo.server.cancelAtPeriodEnd == false) &&
                                            <button
                                                className="btn btn-light btn-active-light-primary me-2"
                                                onClick={async (e) => {

                                                    setDisableSubscriptionButtons(true)

                                                    const result = await swal.questionWithConfirm(
                                                        intl.formatMessage({id: 'SWEETALERT.MESSAGE.CONFIRM'}),
                                                        intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.MESSAGE.CANCEL_SUBSCRIPTION"})
                                                    )
                                                    if (result.isConfirmed) {
                                                        const response = await subscriptionActions.cancelSubscription({
                                                            organisationId: organisation.id,
                                                            packageId: subscriptionInfo.server?.packageId!
                                                        })

                                                        if (response.isSucceed) {
                                                            window.location.href = response.data.sessionUrl
                                                        } else {
                                                            toastify.error()
                                                        }

                                                    } else {
                                                        setDisableSubscriptionButtons(false)
                                                    }

                                                }}
                                            >
                                                {intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.BUTTON.CANCEL_SUBSCRIPTION"})}
                                            </button>
                                        }
                                        {

                                            <button className='btn btn-primary' onClick={() => {
                                                dispatch(subscriptionActions.showUpgradeModal({
                                                    state: true,
                                                    packageType: PackageType.Server,
                                                    currentPlan: organisation.packages.server?.packageKey ?? null,
                                                    currentPeriod: subscriptionInfo.server?.periodType ?? null
                                                }))
                                            }}>
                                                {intl.formatMessage({id: 'ORGANISATION.SUBSCRIPTION.BUTTON.UPGRADE_PLAN'})}
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='card  mb-5 mb-xl-10'>
                        <div className='card-header bg-dark min-h-50px'>
                            <h3 className='card-title text-white'>
                                {intl.formatMessage({id: 'ORGANISATION.SUBSCRIPTION.CMS_WORDPRESS.TITLE'})}
                            </h3>
                        </div>

                        <div className='card-body'>
                            <div className='row'>
                                <div className='col-lg-7'>
                                    {!subscriptionInfo.cms ? (
                                            <>
                                                <h3 className='mb-2'>
                                                    {intl.formatMessage({id: 'ORGANISATION.SUBSCRIPTION.PACKAGE.TRIAL'})}
                                                </h3>

                                                <div>
                                                    {intl.formatMessage(
                                                        {id: 'ORGANISATION.SUBSCRIPTION.MESSAGE.USING_FREEMIUM_PLAN_SUB_MESSAGE'},
                                                        {br: <br/>}
                                                    )}
                                                </div>
                                            </>
                                        ) :
                                        (
                                            <>
                                                <table className="table fs-5 fw-semibold gs-0 gy-2 gx-2 m-0">
                                                    <tbody>
                                                    <tr>
                                                        <td className="text-gray-500 min-w-175px w-175px">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.LABEL.PLAN"})}:</td>
                                                        <td className="text-gray-800 min-w-200px">
                                                            <a href="#" className="text-gray-800 fw-bolder">{subscriptionInfo.cms.packageName}</a>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-gray-500">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.LABEL.PRICE"})}:</td>
                                                        <td className="text-gray-800">
                                                            €{formatPrice(subscriptionInfo.cms.unitAmountDecimal)} / {intl.formatMessage({id: subscriptionInfo.cms.periodType == 'Monthly' ? "ORGANISATION.SUBSCRIPTION.PER_MONTH" : "ORGANISATION.SUBSCRIPTION.PER_YEAR"})}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-gray-500">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.LABEL.PAYMENT_PERIOD"})}:</td>
                                                        <td className="text-gray-800">
                                                            {intl.formatMessage({id: subscriptionInfo.cms.periodType == 'Monthly' ? "ORGANISATION.SUBSCRIPTION.PER_MONTH" : "ORGANISATION.SUBSCRIPTION.PER_YEAR"})}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-gray-500">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.LABEL.VALID_DATE"})}:</td>
                                                        <td className="text-gray-800">{formatDate(subscriptionInfo.cms.currentPeriodEnd)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-gray-500">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.LABEL.STATUS"})}:</td>
                                                        <td className="text-gray-800">
                                                            {
                                                                (subscriptionInfo.cms.status == 'active' && subscriptionInfo.cms.cancelAtPeriodEnd == false) &&
                                                                <span
                                                                    className="text-success">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.SUBSCRIPTION_STATUS_ACTIVE"})}</span>
                                                            }
                                                            {
                                                                (subscriptionInfo.cms.status == 'active' && subscriptionInfo.cms.cancelAtPeriodEnd == true) &&
                                                                <span
                                                                    className="text-warning">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.SUBSCRIPTION_STATUS_CANCELED"})}<br/><br/>
                                                                    {intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.SUBSCRIPTION_STATUS_CANCELED_SUB_MESSAGE"},
                                                                        {date: formatDate(subscriptionInfo.cms.currentPeriodEnd)})}</span>
                                                            }</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </>
                                        )}
                                </div>
                                <div className='col-lg-5'>
                                    <div className='d-flex justify-content-end pb-0 px-0'>

                                        {
                                            (subscriptionInfo.cms && subscriptionInfo.cms.status == "active" && subscriptionInfo.cms.cancelAtPeriodEnd == false) &&
                                            <button
                                                className="btn btn-light btn-active-light-primary me-2"
                                                onClick={async (e) => {

                                                    setDisableSubscriptionButtons(true)

                                                    const result = await swal.questionWithConfirm(
                                                        intl.formatMessage({id: 'SWEETALERT.MESSAGE.CONFIRM'}),
                                                        intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.MESSAGE.CANCEL_SUBSCRIPTION"})
                                                    )
                                                    if (result.isConfirmed) {
                                                        const response = await subscriptionActions.cancelSubscription({
                                                            organisationId: organisation.id,
                                                            packageId: subscriptionInfo.cms?.packageId!
                                                        })

                                                        if (response.isSucceed) {
                                                            window.location.href = response.data.sessionUrl
                                                        } else {
                                                            toastify.error()
                                                        }

                                                    } else {
                                                        setDisableSubscriptionButtons(false)
                                                    }

                                                }}
                                            >
                                                {intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.BUTTON.CANCEL_SUBSCRIPTION"})}
                                            </button>
                                        }
                                        {

                                            <button className='btn btn-primary' onClick={() => {
                                                dispatch(subscriptionActions.showUpgradeModal({
                                                    state: true,
                                                    packageType: PackageType.Cms,
                                                    currentPlan: organisation.packages.cms?.packageKey ?? null,
                                                    currentPeriod: subscriptionInfo.cms?.periodType ?? null
                                                }))
                                            }}>
                                                {intl.formatMessage({id: 'ORGANISATION.SUBSCRIPTION.BUTTON.UPGRADE_PLAN'})}
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='card  mb-5 mb-xl-10'>
                        <div className='card-header bg-dark min-h-50px'>
                            <h3 className='card-title text-white'>
                                {intl.formatMessage({id: 'ORGANISATION.SUBSCRIPTION.SOFTWARE_PACKAGE.TITLE'})}
                            </h3>
                        </div>

                        <div className='card-body'>
                            <div className='row'>
                                <div className='col-lg-7'>
                                    {!subscriptionInfo.softwarePackage ? (
                                            <>
                                                <h3 className='mb-2'>
                                                    {intl.formatMessage({id: 'ORGANISATION.SUBSCRIPTION.PACKAGE.TRIAL'})}
                                                </h3>

                                                <div>
                                                    {intl.formatMessage(
                                                        {id: 'ORGANISATION.SUBSCRIPTION.MESSAGE.USING_FREEMIUM_PLAN_SUB_MESSAGE'},
                                                        {br: <br/>}
                                                    )}
                                                </div>
                                            </>
                                        ) :
                                        (
                                            <>
                                                <table className="table fs-5 fw-semibold gs-0 gy-2 gx-2 m-0">
                                                    <tbody>
                                                    <tr>
                                                        <td className="text-gray-500 min-w-175px w-175px">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.LABEL.PLAN"})}:</td>
                                                        <td className="text-gray-800 min-w-200px">
                                                            <a href="#" className="text-gray-800 fw-bolder">{subscriptionInfo.softwarePackage.packageName}</a>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-gray-500">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.LABEL.PRICE"})}:</td>
                                                        <td className="text-gray-800">
                                                            €{formatPrice(subscriptionInfo.softwarePackage.unitAmountDecimal)} / {intl.formatMessage({id: subscriptionInfo.softwarePackage.periodType == 'Monthly' ? "ORGANISATION.SUBSCRIPTION.PER_MONTH" : "ORGANISATION.SUBSCRIPTION.PER_YEAR"})}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-gray-500">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.LABEL.PAYMENT_PERIOD"})}:</td>
                                                        <td className="text-gray-800">
                                                            {intl.formatMessage({id: subscriptionInfo.softwarePackage.periodType == 'Monthly' ? "ORGANISATION.SUBSCRIPTION.PER_MONTH" : "ORGANISATION.SUBSCRIPTION.PER_YEAR"})}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-gray-500">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.LABEL.VALID_DATE"})}:</td>
                                                        <td className="text-gray-800">{formatDate(subscriptionInfo.softwarePackage.currentPeriodEnd)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-gray-500">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.LABEL.STATUS"})}:</td>
                                                        <td className="text-gray-800">
                                                            {
                                                                (subscriptionInfo.softwarePackage.status == 'active' && subscriptionInfo.softwarePackage.cancelAtPeriodEnd == false) &&
                                                                <span
                                                                    className="text-success">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.SUBSCRIPTION_STATUS_ACTIVE"})}</span>
                                                            }
                                                            {
                                                                (subscriptionInfo.softwarePackage.status == 'active' && subscriptionInfo.softwarePackage.cancelAtPeriodEnd == true) &&
                                                                <span
                                                                    className="text-warning">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.SUBSCRIPTION_STATUS_CANCELED"})}<br/><br/>
                                                                    {intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.SUBSCRIPTION_STATUS_CANCELED_SUB_MESSAGE"},
                                                                        {date: formatDate(subscriptionInfo.softwarePackage.currentPeriodEnd)})}</span>
                                                            }</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </>
                                        )}
                                </div>
                                <div className='col-lg-5'>
                                    <div className='d-flex justify-content-end pb-0 px-0'>

                                        {
                                            (subscriptionInfo.softwarePackage && subscriptionInfo.softwarePackage.status == "active" && subscriptionInfo.softwarePackage.cancelAtPeriodEnd == false) &&
                                            <button
                                                className="btn btn-light btn-active-light-primary me-2"
                                                onClick={async (e) => {

                                                    setDisableSubscriptionButtons(true)

                                                    const result = await swal.questionWithConfirm(
                                                        intl.formatMessage({id: 'SWEETALERT.MESSAGE.CONFIRM'}),
                                                        intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.MESSAGE.CANCEL_SUBSCRIPTION"})
                                                    )
                                                    if (result.isConfirmed) {
                                                        const response = await subscriptionActions.cancelSubscription({
                                                            organisationId: organisation.id,
                                                            packageId: subscriptionInfo.softwarePackage?.packageId!
                                                        })

                                                        if (response.isSucceed) {
                                                            window.location.href = response.data.sessionUrl
                                                        } else {
                                                            toastify.error()
                                                        }

                                                    } else {
                                                        setDisableSubscriptionButtons(false)
                                                    }

                                                }}
                                            >
                                                {intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.BUTTON.CANCEL_SUBSCRIPTION"})}
                                            </button>
                                        }
                                        {

                                            <button className='btn btn-primary' onClick={() => {
                                                dispatch(subscriptionActions.showUpgradeModal({
                                                    state: true,
                                                    packageType: PackageType.SoftwarePackage,
                                                    currentPlan: organisation.packages.softwarePackage?.packageKey ?? null,
                                                    currentPeriod: subscriptionInfo.softwarePackage?.periodType ?? null
                                                }))
                                            }}>
                                                {intl.formatMessage({id: 'ORGANISATION.SUBSCRIPTION.BUTTON.UPGRADE_PLAN'})}
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }

        </>
    )
}
